
const normalize = (str = "") => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase()

export default normalize
